module.exports = __webpack_public_path__ + "static/img/callOut.9d5acd1b.png";